import { Typography, Box, IconButton, Switch, FormGroup, CircularProgress, FormControl, InputLabel, Select, TextField, RadioGroup, FormControlLabel, Radio, Tooltip, List, ListItem, ListItemText } from '@mui/material';
import Button from '@mui/material/Button';
import { Component, createRef, memo, PureComponent, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { ArrowBack, CreateNewFolderOutlined, Home, Settings, TurnedInNotTwoTone, UploadFile, UploadFileOutlined, Warning, Refresh, Search, PhotoLibrary, DeleteSweep, RestoreFromTrash, DeleteForeverOutlined, FolderOutlined, InsertDriveFileOutlined } from '@mui/icons-material';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import util from '../../util';
import { snackCaller } from '../../App';
import { useUploadActions, formatBytes } from '../../uploads/UploadsContext';

import Image from '../../components/Image';

import FolderLogo from "../../svg/folder.svg"
import GenericLogo from "../../svg/generic.svg"
import { FixedSizeGrid } from "react-window";
import FileViewer from '../../components/FileViewer';

class Item extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            decryptedData: null,
            selected: false,
        };
    }

    componentDidMount() {
        this.setState({ selected: this.props.selected });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.selected !== this.props.selected) {
            this.setState({ selected: this.props.selected });
        }
    }

    render() {
        const {
            data,
            setContextMenu,
            setSelectedItem,
            refreshFileReferences,
            dragStart,
            handleItemClick,
            disableDiskCache,
        } = this.props;

        const { decryptedData, selected } = this.state;
        const cardWidth = 140;
        const cardHeight = 210;
        const previewSize = 100;
        const previewSource = data.thumbnail;

            const accessMode = data?.accessMode;
        const isSharedFile =
          (data.type !== "folder" &&
           (accessMode === "public" ||
            accessMode === "public_until" ||
            accessMode === "limited")) ||
          (data.type === "folder" &&
           (accessMode === "public" ||
            accessMode === "public_until"));

        let badgeText = null;
        if (accessMode === "public") {
          badgeText = data.type === "folder" ? "Public folder" : "Public";
        } else if (accessMode === "public_until" && data.publicUntil) {
          const d = new Date(data.publicUntil);
          if (!isNaN(d)) {
            const m = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            badgeText = `Expires ${m}/${day}`;
          }
        } else if (accessMode === "limited" && data.type !== "folder") {
          const max = Number(data.maxDownloads ?? 0);
          const used = Number(data.currentDownloads ?? 0);
          if (max > 0) {
            badgeText = `${Math.max(max - used, 0)} left`;
          }
        }

        return (
            <Button
                id={data._id}
                sx={{
                    height: cardHeight,
                    width: cardWidth,
                    backgroundColor: selected ? '#303030' : '#151515',
                    cursor: 'pointer',
                    flexDirection: 'column',
                    position: 'relative',
                    border: isSharedFile ? '1px solid #9f3aeb' : 'none',
                    borderRadius: 2,
                }}
                onContextMenu={(event) => {
                    event.preventDefault();
                    setContextMenu({
                        mouseX: event.clientX - 2,
                        mouseY: event.clientY - 4,
                    });
                    setSelectedItem(data);
                }}
                onDragOver={(event) => {
                    event.preventDefault();
                }}
                onDragEnter={(event) => {
                    event.preventDefault();
                    this.setState({ selected: true });
                }}
                onDragLeave={(event) => {
                    event.preventDefault();
                    this.setState({ selected: false });
                }}
                onDrop={(event) => {
                    dragStart(false);
                    if (data.type !== 'folder') return;
                    event.preventDefault();
                    if (event.dataTransfer.getData('text/plain') === data._id) {
                        return console.log("Can't drop on itself");
                    }
                    this.setState({ selected: false });

                    util
                        .postRequest('/api/content/move', {
                            id: event.dataTransfer.getData('text/plain'),
                            parent: data._id,
                        })
                        .then(() => {
                            refreshFileReferences();
                        });
                }}
                draggable={true}
                onDragStart={(event) => {
                    event.dataTransfer.setData('text/plain', data._id);
                    event.dataTransfer.effectAllowed = 'move';
                    dragStart(true);
                }}
                onDragEnd={(event) => {
                    dragStart(false);
                }}
                onClick={(ev) => {
                    handleItemClick(ev, data, decryptedData);
                }}
            >
                <Box
                    sx={{
                        height: previewSize,
                        width: previewSize,
                        margin: 'auto',
                        marginTop: 2,
                        position: 'relative',
                        pointerEvents: 'none',
                    }}
                >
                    {data.type !== 'folder' ? (
                        (isImagePreviewableFilename(data.filename) && window?.user?.thumbnail && previewSource) ? (
                            <Image
                                src={previewSource}
                                disableDiskCache={disableDiskCache}
                                setDecryptedData={(data) => this.setState({ decryptedData: data })}
                                style={{
                                    height: '100%',
                                    width: '100%',
                                    objectFit: 'cover',
                                    borderRadius: 6,
                                    zIndex: 0.1,
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                }}
                            />
                        ) : (
                            <div>
                                <img
                                    src={GenericLogo}
                                    style={{
                                        height: '100%',
                                        width: '100%',
                                        objectFit: 'cover',
                                        zIndex: 0.1,
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                    }}
                                />
                                <Typography
                                    sx={{
                                        position: 'absolute',
                                        bottom: 20,
                                        width: '100%',
                                        color: '#fff',
                                        padding: 1,
                                        textAlign: 'center',
                                        fontFamily: 'Russo One',
                                        fontWeight: 100,
                                        fontSize: 20,
                                    }}
                                >
                                    {data.filename.split('.').length === 1
                                        ? '??'
                                        : data.filename.split('.').pop().slice(0, 3)}
                                </Typography>
                            </div>
                        )
                    ) : data.type === 'folder' ? (
                        <div>
                            {data.childPreview && (() => {
                              const base = util.GetFunctionRoot();
                              const folderTokenParam = data.downloadToken ? `?token=${encodeURIComponent(data.downloadToken)}` : "";
                              return (
                                <img
                                  src={`${base}/file/${data.childPreview}${folderTokenParam}`}
                                    alt="content"
                                    style={{
                                        height: '60%',
                                        width: '60%',
                                        objectFit: 'cover',
                                        position: 'absolute',
                                        top: 9,
                                        left: 32,
                                        borderRadius: 10,
                                    }}
                                />
                              );
                            })()}
                            <img
                                src={FolderLogo}
                                alt="Item"
                                style={{
                                    height: '100%',
                                    width: '100%',
                                    objectFit: 'cover',
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    position: 'absolute',
                                }}
                            />
                        </div>
                    ) : (
                        <div>
                            <p>unknown filetype</p>
                        </div>
                    )}
                </Box>

                <Typography
                    sx={{
                        textAlign: 'center',
                        margin: 'auto',
                        wordBreak: 'break-word',
                        color: '#fff',
                        textTransform: 'none',
                        maxWidth: cardWidth - 16,
                    }}
                >
                    {data.filename.split('$Ğ!Ğ$')[0].length > 30
                        ? data.filename.split('$Ğ!Ğ$')[0].substring(0, 30) + '...'
                        : data.filename.split('$Ğ!Ğ$')[0]}
                </Typography>

                {(isSharedFile && badgeText) && (
                    <Tooltip
                        title={
                          accessMode === "public_until" && data.publicUntil
                            ? new Date(data.publicUntil).toLocaleString()
                            : ""
                        }
                    >
                      <Box
                        sx={{
                          position: 'absolute',
                          top: 2,
                          right: 2,
                          backgroundColor: '#9f3aeb',
                          borderRadius: 6,
                          px: 1.5,
                          py: 0.2,
                          fontSize: 7,
                          color: '#fff',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          maxWidth: cardWidth - 8,
                          zIndex: 3,
                        }}
                      >
                        {badgeText}
                      </Box>
                    </Tooltip>
                )}
            </Button>
        );
    }
}

const Grid = ({ fileData, columnCount, itemWidth, gridWidth, gridHeight, refreshFileReferences, dragStart, handleItemClick, selectedItems, setContextMenu, setSelectedItem }) => {
    const gridRef = useRef(null);

    const renderItem = ({ index, style }) => {
        const file = fileData[index];

        if (!file) return null;

        return (
            <div key={file._id} style={style}>
                <Item
                    data={file}
                    refreshFileReferences={refreshFileReferences}
                    dragStart={dragStart}
                    handleItemClick={handleItemClick}
                    selected={selectedItems?.some(item => item._id === file._id)}
                    setContextMenu={setContextMenu}
                    setSelectedItem={setSelectedItem}
                />
            </div>
        );
    };

    return (
        <FixedSizeGrid
            columnCount={columnCount}
            rowCount={Math.ceil(fileData.length / columnCount)}
            columnWidth={itemWidth}
            rowHeight={210}
            width={gridWidth}
            height={gridHeight}
            ref={gridRef}
            style={{
                overflowX: 'hidden',
                overflowY: 'auto',
            }}
            itemData={fileData}
            itemRenderer={renderItem}
        />
    );
};


class GridView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            length: props.fileData(),
        }

        this.LL = 0
        this.loading = false
    }

    shouldComponentUpdate(nextProps, nextState) {
        return true
        if (this.props.selectedItems?.length !== nextProps.selectedItems?.length) return true
        if ((this.props.selectedItems?.length > 0 && nextProps.selectedItems?.length > 0) && (this.props.selectedItems[0]._id !== nextProps.selectedItems[0]._id)) return true

        if (nextProps.fileData().length !== this.state.length) {
            this.state.length = nextProps.fileData().length

            return true
        }

        return false
    }

    render() {
        let {
            columnCount,
            itemWidth,
            gridWidth,
            gridHeight,
            gridRef,
            refreshFileReferences,
            dragStart,
            handleItemClick,
            selectedItems,
            setContextMenu,
            setSelectedItem,
            fileData,
            hasMore,
            alwaysFullLoad,
            disableDiskCache,
        } = this.props

        return (
            <FixedSizeGrid
                columnCount={columnCount}
                rowCount={Math.ceil(fileData().length / columnCount)}
                columnWidth={itemWidth}
                rowHeight={210}
                width={gridWidth}
                height={gridHeight}
                ref={gridRef}
                onScroll={(e) => {
                    // fire when 75% of the grid is scrolled
                    // calculate the scroll height and the client height with the element height and item count
                    let scrollHeight = 210 * Math.ceil(fileData().length / columnCount) - gridHeight
                    if (e.scrollTop >
                        scrollHeight * 0.75
                        && this.LL + 1000 < Date.now()
                        && !this.loading
                        && hasMore
                        && !alwaysFullLoad) {
                        console.log("FIRE")
                        this.LL = Date.now()
                        this.loading = true
                        refreshFileReferences(undefined, null, null, () => {
                            this.LL = Date.now()
                            this.loading = false
                        });
                    }
                }}
                style={{
                    overflowX: "hidden",
                    overflowY: "auto",

                }}
            >
                {({ columnIndex, rowIndex, style }) => {
                    const index = rowIndex * columnCount + columnIndex;
                    const file = fileData()[index];

                    if (!file) return null;

                    return (
                        <div key={file._id} style={style}>
                            <Item
                                data={file} refreshFileReferences={refreshFileReferences} dragStart={dragStart} handleItemClick={handleItemClick} selected={selectedItems?.some(item => item._id === file._id)} setContextMenu={setContextMenu} setSelectedItem={setSelectedItem} disableDiskCache={disableDiskCache}
                            />
                        </div>
                    );
                }}
            </FixedSizeGrid>
        )
    }
}

let targetP = {
    _id: "",
    item: {}
}

export function setParentID(id) {
    targetP = id
}

const IMAGE_PREVIEW_EXTENSIONS = ["png", "jpg", "jpeg", "webp", "gif", "jfif", "avif", "heic", "heif", "apng"];
const VIDEO_PREVIEW_EXTENSIONS = ["mp4", "webm", "mov", "avi", "mkv", "flv", "wmv", "m4v", "ogv"];
const AUDIO_PREVIEW_EXTENSIONS = ["mp3", "wav", "ogg", "oga", "m4a", "aac", "flac", "opus", "weba"];

function getFileExtension(filename = "") {
    const originalName = filename.split("$Ğ!Ğ$")[0] || "";
    return originalName.split('.').pop()?.toLowerCase() || "";
}

function isPreviewableFile(item = {}) {
    const extension = getFileExtension(item.filename);
    const mimetype = (item.mimetype || "").toLowerCase();

    return IMAGE_PREVIEW_EXTENSIONS.includes(extension)
        || VIDEO_PREVIEW_EXTENSIONS.includes(extension)
        || AUDIO_PREVIEW_EXTENSIONS.includes(extension)
        || mimetype.startsWith("image/")
        || mimetype.startsWith("video/")
        || mimetype.startsWith("audio/")
        || mimetype.includes("jfif");
}

function isImagePreviewableFilename(filename = "") {
    const extension = getFileExtension(filename);
    return IMAGE_PREVIEW_EXTENSIONS.includes(extension);
}


function getSharedFolderIdFromHash() {
  try {
    const hash = window.location.hash || "";
    if (!hash.includes("?folder=")) return null;
    const afterHash = (hash.startsWith("#")) ? hash.slice(1) : hash;
    const qsPart = afterHash.split("?")[1];
    if (!qsPart) return null;
    const params = new URLSearchParams(qsPart);
    return params.get("folder") || null;
  } catch {
    return null;
  }
}

function getFolderIdFromSearch(search = "") {
  try {
    return new URLSearchParams(search).get("folder") || null;
  } catch {
    return null;
  }
}

function buildContentManagerUrl(parentId) {
  return parentId ? `/contentManager?folder=${encodeURIComponent(parentId)}` : "/contentManager";
}

const CDNRoot = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    // The shared link's root folder must stay fixed for the whole visit, even after the
    // address bar starts pointing at a subfolder.
    const sharedFolderId = useRef(getSharedFolderIdFromHash()).current;
    const initialFolderId = useRef(getFolderIdFromSearch(location.search) || sharedFolderId).current;
    const [value, setValue] = useState(0);
    const [user, setUser] = useState(JSON.parse(localStorage.getItem("user") || "false") || {});
    const [currentDir, setCurrentDir] = useState(() => buildDirFromStack(
        Array.isArray(location.state?.cdnStack) ? location.state.cdnStack : []
    ));
    const [currentParent, setCurrentParentD] = useState(initialFolderId);
    const [pathStack, setPathStack] = useState(
        Array.isArray(location.state?.cdnStack) ? location.state.cdnStack : []
    );
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null);
    const gridRef = useRef(null);
    const lastUrlFolderRef = useRef(initialFolderId || null);
    function buildDirFromStack(stack) {
        if (!stack?.length) return "/";
        return `/${stack.map((entry) => entry.filename).join("/")}/`;
    }

    function applyFolder(parentId, nextStack) {
        setPathStack(nextStack);
        setCurrentDir(buildDirFromStack(nextStack));

        setLoading(true)
        setFileData([])
        setSelectedItems(null)
        setCurrentParentD(parentId || null)
        refreshFileReferences(parentId || null, true);
    }

    function navigateByStack(nextStack, explicitParentId, options = {}) {
        // Anonymous visitors follow a shared link, so their navigation is rooted at the
        // shared folder rather than the owner's real root.
        const baseParent = user.username == null && sharedFolderId ? sharedFolderId : null;
        const nextParent = explicitParentId !== undefined
            ? explicitParentId
            : (nextStack[nextStack.length - 1]?._id || baseParent);

        if ((nextParent || null) === (currentParent || null) && JSON.stringify(nextStack) === JSON.stringify(pathStack)) {
            return;
        }

        // Keep the address bar in sync so browser back/forward can replay folder moves.
        lastUrlFolderRef.current = nextParent || null;
        applyFolder(nextParent, nextStack);
        navigate(buildContentManagerUrl(nextParent), {
            replace: !!options.replace,
            state: { cdnStack: nextStack, cdnParent: nextParent || null },
        });
    }

    function setCurrentParent(id, block) {
        setLoading(true)
        setFileData([])
        setSelectedItems(null)
        setCurrentParentD(id || null)
        if (!block) refreshFileReferences(id || null, true);
    }

    function openFolder(item) {
        console.log("OPENING ", item)
        navigateByStack([...pathStack, { _id: item._id, filename: item.filename }]);
    }

    function goBackOne() {
        if (!pathStack.length) return;
        navigateByStack(pathStack.slice(0, -1));
    }

    function goHome() {
        navigateByStack([]);
    }
    const [contextMenu, setContextMenu] = useState(null);
    const [fileDatas, setFileData] = useState([]);
    const [cdnAutoConvertOptOut, setCdnAutoConvertOptOut] = useState(null);
    const [thumbnailVisible, setThumbnailVisible] = useState(user.thumbnail);
    const [hasMore, setHasMore] = useState(false);
    const [sortBy, setSortBy] = useState(Number(localStorage.getItem("cdnSortBy") || 0));
    const [sortOrder, setSortOrder] = useState(Number(localStorage.getItem("cdnSortOrder") || -1));
    const [alwaysFullLoad, setAlwaysFullLoad] = useState(localStorage.getItem("cdnAlwaysFullLoad") === "true");
    const [disableDiskCache, setDisableDiskCache] = useState(localStorage.getItem("ifmwDisableDiskCache") === "true");
    const listPreferenceInitializedRef = useRef(false);
    const [lastClick, setLastClick] = useState(0);

    const gridParentRef = useRef(null);
    const [gridWidth, setGridWidth] = useState(100); // Adjust for padding
    const [gridHeight, setGridHeight] = useState(100);
    const [fileModalVisible, setFileModalVisible] = useState(false)
    const [fileModalData, setFileModalData] = useState({})

    useEffect(() => {
        const handleResize = () => {
            if (gridParentRef.current) {
                // Adjust these values as needed for padding or margins
                setGridWidth(gridParentRef.current.clientWidth);
                setGridHeight(gridParentRef.current.clientHeight);
            } else {
                console.log("RECALL!")
                handleResize()
            }
        };

        // Call handleResize initially in case the component mounts with the correct size
        handleResize();

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
      const hash = window.location.hash || "";
      if (!hash.includes("?folder=")) return;

      try {
        const afterHash = (hash.startsWith("#")) ? hash.slice(1) : hash;
        const qsPart = afterHash.split("?")[1];
        if (!qsPart) return;

        const params = new URLSearchParams(qsPart);
        const folderId = params.get("folder");
        if (!folderId) return;

        targetP._id = folderId;
        targetP.item = { type: "folder" };
      } catch (_) {
        // ignore parse errors
      }
    }, []);

    // Calculate grid dimensions
    const itemWidth = 140;
    const columnCount = Math.max(1, Math.floor(gridWidth / itemWidth));
    const colCRef = useRef(columnCount);

    function fileData() {
        if (fileDatas.length === 0) return [];
        const pathParts = currentDir.replace(/\$Ğ!Ğ\$.{6}/g, '').split('/').filter(part => part !== '');
        let parentId = null;

        for (const part of pathParts) {
            const parent = fileDatas.find(file => file.parent === parentId && file.filename.replace(/\$Ğ!Ğ\$.{6}/g, '') === part);
            if (parent) {
                parentId = parent._id;
            } else {
                break;
            }
        }

        parentId = parentId || currentParent || null;

        return fileDatas
    }

    const [newFolderDialog, setNewFolderDialog] = useState(false);
    const [deleteItemDialog, setDeleteItemDialog] = useState(false);
    const [concurrenceDialog, setConcurrenceDialog] = useState(false);
    const [concurrenceInput, setConcurrenceInput] = useState(user.concurrence || 1);
    const [uploadChunkConcurrenceInput, setUploadChunkConcurrenceInput] = useState(user.uploadChunkConcurrence || 1);
    const [selectedItems, setSelectedItems] = useState(null);
    const [sIW, setSIW] = useState(false);
    const [totalSize, setTotalSize] = useState(0);

    function selectedItem() {
        if (selectedItems?.length === 1) return selectedItems[0];
        return selectedItems;
    }

    function isEncryptedFiletype(filename) {
        return [...IMAGE_PREVIEW_EXTENSIONS, ...VIDEO_PREVIEW_EXTENSIONS, ...AUDIO_PREVIEW_EXTENSIONS].some(v => getFileExtension(filename) === v);
    }

    function setSelectedItem(item) {
        if (item) {
            if (!selectedItems) return setSelectedItems([item]);

            if (!selectedItems.includes(item)) {
                setSelectedItems([...selectedItems, item]);
            }
        } else {
            setSelectedItems(null);
        }
    }

    function getSize() {
        let size = 0;
        for (const item of selectedItems) {
            if (item.type === "file")
                size += item.size;
        }
        // item.size is in bytes; format for display
        return formatBytes(size)
    }

    const [isDragging, setIsDragging] = useState(false);

    function dragStart(val) {
        setIsDragging(val);
    }

    const refreshMetaRef = useRef({
        lastRequestAt: 0,
        requestSeq: 0,
    });
    const lastParentRef = useRef(null);
    let blockuntil = Number.MIN_SAFE_INTEGER;
    function refreshFileReferences(id, force = false, tID, cb) {
        if (Date.now() < blockuntil) {
            console.warn(`RFR Block until ${blockuntil} (in ${blockuntil - Date.now()}ms)`)
        }
        blockuntil = Date.now() + 400
        console.error(`RFR id: ${id} force: ${force} tID: ${tID}`)
        console.log(targetP)
        let resolvedParent = id !== undefined ? id : currentParent;
        const parentChanged = resolvedParent !== lastParentRef.current;
        const skipThrottle = force || parentChanged;

        if (!skipThrottle && refreshMetaRef.current.lastRequestAt + 1000 > Date.now()) {
            cb && cb();
            return;
        }

        refreshMetaRef.current.lastRequestAt = Date.now();
        const requestSeq = ++refreshMetaRef.current.requestSeq;

        setError(false)

        const shouldReset = alwaysFullLoad || force || fileDatas.length === 0 || parentChanged;

        if (targetP._id !== "") {
            if (targetP?.item?.type === "folder") {
                resolvedParent = targetP._id
            } else {
                resolvedParent = targetP.item.parent
            }

            setCurrentParent(resolvedParent, true)

            targetP._id = ""
            console.log("DIRECT NAVIGATION TO ", resolvedParent)
        }

        const base = util.GetFunctionRoot();
        // If not logged in and we are viewing a shared folder via ?folder=,
        // use the public endpoint instead of myFiles.
        if (!user && sharedFolderId && (resolvedParent === sharedFolderId)) {
            setLoading(true);

            const offset = shouldReset ? 0 : fileDatas.length;
            const limit = alwaysFullLoad ? 10000 : 100;

            fetch(`${base}/api/content/folder/${encodeURIComponent(resolvedParent)}?offset=${offset}&limit=${limit}`, {
                method: "GET",
                headers: { "Content-Type": "application/json" }
            })
                .then(async (res) => {
                    if (!res.ok) {
                        throw new Error("Shared folder not accessible");
                    }
                    const json = await res.json();

                    return {
                        data: (json.data || []).map((file, i) => {
                            const tokenParam = file.downloadToken
                                ? `?token=${encodeURIComponent(file.downloadToken)}`
                                : "";

                            return {
                                ...file,
                                url: `${base}/file/${file._id}${tokenParam}`,
                                thumbnail: (file.thumbnail
                                    ? `${base}/file/${file.thumbnail}${tokenParam}`
                                    : `${base}/file/${file._id}${tokenParam}`),
                                largeThumbnail: (file.largeThumbnail
                                    ? `${base}/file/${file.largeThumbnail}${tokenParam}`
                                    : file.thumbnail
                                        ? `${base}/file/${file.thumbnail}${tokenParam}`
                                        : `${base}/file/${file._id}${tokenParam}`),
                                index: i + 1
                            };
                        }),
                        hasMore: json.hasMore,
                        usage: json.usage || { mb: 0 },
                        allowance: "∞",
                        cdnAutoConvertOptOut: false
                    };
                })
                .then((res) => {
                    if (requestSeq !== refreshMetaRef.current.requestSeq) {
                        cb && cb();
                        return;
                    }

                    if (shouldReset) {
                        setFileData(res.data);
                    } else {
                        setFileData((prev) => {
                            let ndata = [...prev, ...res.data];
                            ndata = ndata.filter((item, index) => {
                                return ndata.findIndex(i => i._id === item._id) === index;
                            });
                            return ndata;
                        });
                    }

                    lastParentRef.current = resolvedParent;
                    setLoading(false);
                    cb && cb();
                    setUsage(res.usage);
                    setHasMore(!!res.hasMore);
                    setAllowance(res.allowance || "∞");
                    setCdnAutoConvertOptOut(res.cdnAutoConvertOptOut);

                    setTimeout(() => {
                        if (tID && gridRef.current) {
                            let itemIndex = res.data.findIndex(f => f._id === tID);
                            if (itemIndex < 0) return;

                            const columnIndex = itemIndex % (colCRef.current || columnCount || 10);
                            const rowIndex = Math.floor(itemIndex / (colCRef.current || columnCount || 10));

                            gridRef.current.scrollToItem({
                                columnIndex,
                                rowIndex,
                                align: 'center'
                            });
                        }
                    }, 500);
                })
                .catch((e) => {
                    if (requestSeq !== refreshMetaRef.current.requestSeq) {
                        cb && cb();
                        return;
                    }
                    console.error(e);
                    setError(true);
                    setLoading(false);
                    cb && cb();
                });

            // Early exit: public path handled above.
            return;
        }

        util.postRequest("/api/content/myFiles", {
            parent: resolvedParent,
            offset: shouldReset ? 0 : fileDatas.length,
            limit: alwaysFullLoad ? 10000 : 100,
            sort: sortBy,
            order: sortOrder,
            fullLoad: alwaysFullLoad
        }).then((res) => {
            res.data = res.data.map((file, i) => {
                /*if (document.location.hostname === "localhost" || document.location.hostname === "") {
                    return {
                        ...file,
                        url: `http://localhost:5000/file/${file._id}?k=${file.key}`,
                        thumbnail: `http://localhost:5000/file/${file._id}?k=${file.thumbnail}`,
                        index: i + 1
                    }
                }*/

            const tokenParam = file.downloadToken ? `?token=${encodeURIComponent(file.downloadToken)}` : "";

            return {
                ...file,
                url: `${base}/file/${file._id}${tokenParam}`,
                thumbnail: (file.thumbnail ? `${base}/file/${file.thumbnail}${tokenParam}` : `${base}/file/${file._id}${tokenParam}`),
                largeThumbnail: (file.largeThumbnail
                  ? `${base}/file/${file.largeThumbnail}${tokenParam}`
                  : file.thumbnail
                    ? `${base}/file/${file.thumbnail}${tokenParam}`
                    : `${base}/file/${file._id}${tokenParam}`),
                index: i + 1
            };
            })
            if (requestSeq !== refreshMetaRef.current.requestSeq) {
                cb && cb();
                return;
            }

            if (shouldReset) {
                setFileData(res.data)
            } else {
                setFileData((prev) => {
                    let ndata = [...prev, ...res.data]
                    ndata = ndata.filter((item, index) => {
                        return ndata.findIndex(i => i._id === item._id) === index;
                    })
                    return ndata;
                })
            }

            lastParentRef.current = resolvedParent
            setLoading(false)
            cb && cb()
            setUsage(res.usage)
            setHasMore(!!res.hasMore)
            setAllowance(res.allowance || "∞")
            setCdnAutoConvertOptOut(res.cdnAutoConvertOptOut)
            setTimeout(() => {
                if (tID && gridRef.current) {
                    let itemIndex = res.data.findIndex(f => f._id === tID);

                    if (itemIndex < 0) return

                    const columnIndex = itemIndex % (colCRef.current || columnCount || 10);
                    const rowIndex = Math.floor(itemIndex / (colCRef.current || columnCount || 10));

                    gridRef.current.scrollToItem({
                        columnIndex,
                        rowIndex,
                        align: 'center'
                    });

                }
            }, 500);

        })
            .catch((e) => {
                if (requestSeq !== refreshMetaRef.current.requestSeq) {
                    cb && cb();
                    return;
                }
                console.error(e)
                setError(true)
                setLoading(false)
                cb && cb()
            })
    }

    // Browser back/forward changes the folder in the URL; bring the grid along with it.
    useEffect(() => {
        const folderId = getFolderIdFromSearch(location.search) || getSharedFolderIdFromHash();
        if ((folderId || null) === lastUrlFolderRef.current) return;
        lastUrlFolderRef.current = folderId || null;
        const stack = Array.isArray(location.state?.cdnStack) ? location.state.cdnStack : [];
        applyFolder(folderId, stack);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search, location.state]);

    function openFileViewer(item) {
        setFileModalData(item);
        setFileModalVisible(true);
        // A viewer session is one history entry so the back button closes it instead of
        // leaving the folder.
        navigate(buildContentManagerUrl(currentParent), {
            state: { cdnStack: pathStack, cdnParent: currentParent, cdnViewer: item._id },
        });
    }

    function closeFileViewer() {
        if (location.state?.cdnViewer) {
            navigate(-1);
            return;
        }
        setFileModalVisible(false);
        setFileModalData({});
    }

    useEffect(() => {
        const viewerId = location.state?.cdnViewer;
        if (viewerId) {
            if (fileModalVisible) return;
            const item = fileDatas.find((f) => f._id === viewerId);
            if (item) {
                setFileModalData(item);
                setFileModalVisible(true);
            }
            return;
        }
        if (fileModalVisible) {
            setFileModalVisible(false);
            setFileModalData({});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.state, fileDatas]);

    async function handleItemClick(event, item, decryptedData = null) {
        let isDoubleClick = false

        if (selectedItems?.length === 1 && selectedItems[0]._id === item._id && Date.now() - lastClick < 300) {
            isDoubleClick = true
        }

        setLastClick(Date.now())

        if (isDoubleClick) {
            if (props.isSelectDialog && item.type === "file") {
                props.selectItem(item);
                props.close()
                return
            }
            setSelectedItems([item])

            if (item.type === "folder") {
                openFolder(item);
                return;
            }

            if (item.type === "file") {
                if (decryptedData) return window.open(decryptedData, "_blank");
                if (util.isElectron()) {
                    snackCaller("Downloading File...")
                    let path = await window.ipcRenderer.invoke("downloadFile", {
                        url: item.url,
                        fileName: item.filename
                    })
                    snackCaller("Opening File...")

                    window.ipcRenderer.invoke("openFile", { path: path })
                } else {
                    if (isPreviewableFile(item)) {
                        openFileViewer(item)
                    } else {
                        return window.open(item.url, "_blank");
                    }
                }
            }
        }

        const isShiftPressed = event.shiftKey;
        const isCtrlPressed = event.ctrlKey;

        if (isShiftPressed) {
            if (selectedItems) {
                const firstSelectedItem = selectedItems[0];
                const firstIndex = fileData().indexOf(firstSelectedItem);
                const lastIndex = fileData().indexOf(item);
                const itemsToSelect = fileData().slice(Math.min(firstIndex, lastIndex), Math.max(firstIndex, lastIndex) + 1);
                setSelectedItems(itemsToSelect);
            } else {
                setSelectedItems([item]);
            }
        } else if (isCtrlPressed) {
            if (selectedItems) {
                if (selectedItems.includes(item)) {
                    setSelectedItems(selectedItems.filter((i) => i !== item));
                } else {
                    setSelectedItems([...selectedItems, item]);
                }
            } else {
                setSelectedItems([item]);
            }
        } else {
            //return // FIXME OPTIMIZE
            setSelectedItems([item]);
        }
    }

    // Allow unauthenticated access only when opening a shared folder link.
    if (!user && !sharedFolderId) navigate("/login");

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const [timesIUsedUnnecessaryThingsBecauseOfReact, setTimesIUsedUnnecessaryThingsBecauseOfReact] = useState(0);
    const [usage, setUsage] = useState(0);
    const [allowance, setAllowance] = useState(0);

    // ignore on the first trigger to avoid unnecessary refresh on initial render
    const skip = useRef(true);
    useEffect(() => {
        if (skip.current) {
            skip.current = false;
            return
        }

        if (!listPreferenceInitializedRef.current) {
            listPreferenceInitializedRef.current = true;
            return;
        }

        setLoading(true)
        setFileData([])
        setSelectedItems(null)
        refreshFileReferences(undefined, true)
    }, [sortBy, sortOrder, alwaysFullLoad])

    useEffect(() => {
        refreshFileReferences();

        setInterval(() => {
            if (targetP._id !== "") {
                if (targetP?.item?.type === "folder") {
                    setPathStack([])
                    setCurrentDir("/")
                    setCurrentParent(targetP._id)
                } else {
                    setPathStack([])
                    setCurrentDir("/")
                    setCurrentParentD(targetP.item.parent)
                    setSelectedItems([targetP.item])
                    refreshFileReferences(targetP.item.parent, false, targetP.item._id)
                }

                targetP._id = ""
            }
        }, 200);

        let esclistener = (event) => {
            if (event.key === "Escape") {
                setSelectedItems(null);
            }
        }

        let ctrlaListener = (event) => {
            if (event.key === "a" && event.ctrlKey) {
                event.preventDefault();

                setSelectedItems(fileData());
            }
        }

        /*let deleteListener = (event) => {
            console.log(selectedItems?.length, selectedItem())
            if (event.key === "Delete" && selectedItem()) {
                setDeleteItemDialog(true);
            }
        }*/

        document.addEventListener("keydown", ctrlaListener);
        //document.addEventListener("keydown", deleteListener);
        document.addEventListener("keydown", esclistener);

        return () => {
            document.removeEventListener("keydown", ctrlaListener);
            //document.removeEventListener("keydown", deleteListener);
            document.removeEventListener("keydown", esclistener);
        }
    }, []);

    const onContextMenuClose = (clear) => {
        setContextMenu(null);
        if (clear) setSelectedItem(null);
    }

    const onDeleteDialogClose = () => {
        setDeleteItemDialog(false);
        setTimeout(() => {
            setSelectedItem(null);
        }, 300);
    }

    // ---- recycle bin ----
    const [trashOpen, setTrashOpen] = useState(false);
    const [trashItems, setTrashItems] = useState([]);
    const [trashTotal, setTrashTotal] = useState(0);
    const [trashLoading, setTrashLoading] = useState(false);
    const [trashBusy, setTrashBusy] = useState(false);
    const [purgeTarget, setPurgeTarget] = useState(null); // item id, or "ALL"
    const [purgePassword, setPurgePassword] = useState("");

    const loadTrash = () => {
        setTrashLoading(true);
        util.postRequest("/api/content/trash", { offset: 0, limit: 200 })
            .then((res) => {
                setTrashItems(res?.data || []);
                setTrashTotal(res?.total || 0);
            })
            .catch(() => { })
            .finally(() => setTrashLoading(false));
    };

    const openTrash = () => {
        setTrashOpen(true);
        loadTrash();
    };

    const restoreTrashItem = (id) => {
        setTrashBusy(true);
        util.postRequest("/api/content/trash/restore", { id })
            .then(() => {
                loadTrash();
                refreshFileReferences(undefined, true);
            })
            .catch(() => { })
            .finally(() => setTrashBusy(false));
    };

    const confirmPurge = () => {
        const target = purgeTarget;
        const url = target === "ALL" ? "/api/content/trash/empty" : "/api/content/trash/purge";
        const body = target === "ALL" ? { password: purgePassword } : { id: target, password: purgePassword };
        setTrashBusy(true);
        util.postRequest(url, body)
            .then(() => {
                setPurgeTarget(null);
                setPurgePassword("");
                loadTrash();
            })
            .catch(() => { })
            .finally(() => setTrashBusy(false));
    };

    const [dragging, setDragging] = useState(false);

    const { addUpload, updateUpload, setAborter } = useUploadActions();

    const handleDrag = (event) => {
        if (!event.dataTransfer.types.includes('Files')) return;
        event.preventDefault();
        setDragging(true);
    };

    const handleDragLeave = () => {
        setDragging(false);
    };

    const handleDrop = async (event) => {
        //if (!event?.dataTransfer?.types?.includes('Files')) return;
        if (event.preventDefault) event.preventDefault();
        setDragging(false);

        // Handle the dropped files
        let files = event?.dataTransfer?.files || event;

        // Loop through the files
        const CHUNK_SIZE = await util.uploadChunkSize();

        const chunkConcurrence = Math.max(1, parseInt(user.uploadChunkConcurrence, 10) || 1);
        async function uploadFile(file) {
            // A same-name file is replaced in place instead of being skipped: the backend keeps the
            // old content as a history revision, so re-uploading no longer piles up duplicates.
            const existing = fileDatas.find(f => f.type === "file" && file.name === f.filename?.split("$Ğ!Ğ$")[0]);

            let VCID = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
            const uploadId = VCID;
            addUpload(uploadId, { filename: file.name, size: file.size });

            const maxRetries = 10; // Maximum number of retries for each chunk
            const totalChunks = Math.max(1, Math.ceil(file.size / CHUNK_SIZE));
            let failed = false;
            let cancelled = false;
            let maxReported = 0;

            async function uploadChunk(chunkID) {
                const start = chunkID * CHUNK_SIZE;
                const chunk = file.slice(start, start + CHUNK_SIZE);
                const formData = new FormData();
                formData.append('file', chunk);
                formData.append('parent', currentParent || null);
                formData.append("isChunked", file.size > CHUNK_SIZE);
                formData.append("isLast", chunkID === totalChunks - 1);
                formData.append("name", file.name);
                formData.append("chunkID", chunkID);
                formData.append("vcid", VCID);
                if (existing) {
                    formData.append("overwrite", "true");
                    // ETag of the revision we are replacing, so a concurrent write is not clobbered
                    // (412 = someone landed first). Version is the fallback for older backends.
                    if (existing.etag) formData.append("ifMatch", existing.etag);
                    else if (existing.version != null) formData.append("expectedVersion", String(existing.version));
                }

                const abortRef = { abort: null };
                setAborter(uploadId, () => {
                    cancelled = true;
                    if (abortRef.abort) abortRef.abort();
                });

                let attempts = 0;

                while (attempts < maxRetries && !cancelled) {
                    try {
                        await util.postRequest("/api/content/upload", formData, (percent, { loaded }) => {
                            const fileLoaded = Math.min(file.size, start + loaded);
                            if (fileLoaded > maxReported) {
                                maxReported = fileLoaded;
                                updateUpload(uploadId, { loaded: fileLoaded });
                            }
                        }, 'application/json', abortRef);
                        console.log(`Chunk ${chunkID} upload complete`);
                        const fileLoaded = Math.min(file.size, start + chunk.size);
                        if (fileLoaded > maxReported) {
                            maxReported = fileLoaded;
                            updateUpload(uploadId, { loaded: fileLoaded });
                        }
                        return true;
                    } catch (err) {
                        if (cancelled) return false;
                        console.error(err);
                        attempts++;
                        if (attempts >= maxRetries) {
                            console.error(`Failed to upload chunk ${chunkID} after ${maxRetries} attempts`);
                            return false;
                        }
                    }
                }

                return !cancelled;
            }

            let nextChunk = 0;

            async function worker() {
                while (!failed && !cancelled && nextChunk < totalChunks) {
                    const id = nextChunk++;
                    if (!await uploadChunk(id)) {
                        failed = true;
                        break;
                    }
                }
            }

            const workers = [];
            for (let i = 0; i < Math.min(chunkConcurrence, totalChunks); i++) {
                workers.push(worker());
            }
            await Promise.all(workers);

            if (cancelled) {
                updateUpload(uploadId, { status: "cancelled", error: "Cancelled", endTime: Date.now() });
            } else if (failed) {
                updateUpload(uploadId, { status: "error", error: "Upload failed", endTime: Date.now() });
            } else {
                updateUpload(uploadId, { status: "done", loaded: file.size, endTime: Date.now() });
            }

            if (existing || (!failed && !cancelled)) {
                snackCaller(existing ? `Replaced ${file.name}` : `Uploaded ${file.name}`);
            }
            refreshFileReferences();
        }

        files = Array.from(files)

        let nF = []

        for (let file of files) {
            if (nF[nF.length - 1]?.length >= user.concurrence) {
                nF[nF.length] = [file]
            } else {
                if (!nF[nF?.length - 1 || 0] || nF.length === 0) nF.push([]);
                nF[nF?.length - 1 || 0].push(file)
            }
        }

        for (let batch of nF) {
            let bP = batch.map(f => uploadFile(f))
            await Promise.all(bP)
        }

        refreshFileReferences();
    };

    const [renameDialog, setRenameDialog] = useState(false);
    const [renameFilename, setRenameFilename] = useState("");

    const [historyDialog, setHistoryDialog] = useState(false);
    const [historyItem, setHistoryItem] = useState(null);
    const [historyVersions, setHistoryVersions] = useState([]);
    const [historyLoading, setHistoryLoading] = useState(false);

    const openHistoryDialog = (item) => {
        setHistoryItem(item);
        setHistoryVersions([]);
        setHistoryDialog(true);
        setHistoryLoading(true);
        util.postRequest("/api/content/history", { id: item._id })
            .then((res) => setHistoryVersions(res.data || []))
            .finally(() => setHistoryLoading(false));
    };

    const viewHistoryVersion = (version) => {
        const anchor = document.createElement("a");
        anchor.href = version.url;
        anchor.download = version.filename?.split("$Ğ!Ğ$")[0] || "download";
        anchor.target = "_blank";
        anchor.rel = "noreferrer";
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
    };

    const [accessDialogOpen, setAccessDialogOpen] = useState(false);
    const [accessMode, setAccessMode] = useState("private");
    const [publicUntilValue, setPublicUntilValue] = useState("");
    const [maxDownloadsValue, setMaxDownloadsValue] = useState(10);

    const openAccessDialog = () => {
      if (!selectedItems || !Array.isArray(selectedItems) || selectedItems.length === 0) return;

      const items = Array.from(selectedItems);
      if (items.length === 0) return;

      let mode = "private";
      let puVal = "";
      let mdVal = 10;

      // Folders do not support "limited" mode. If selection is only folders, default to private/public/public_until-safe mode.
      const hasFolders = items.some(i => i.type === "folder");
      const filesOnly = !hasFolders;

      if (items.length === 1 && items[0].accessMode && items[0].accessMode !== "private") {
        const f = items[0];
        mode = f.accessMode;
        if (mode === "public_until" && f.publicUntil) {
          const d = new Date(f.publicUntil);
          if (!isNaN(d)) {
            const pad = (n) => String(n).padStart(2, "0");
            const local = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
            puVal = local;
          }
        }
        if (mode === "limited" && f.type !== "folder" && (f.maxDownloads ?? 0) > 0) {
          mdVal = Number(f.maxDownloads);
        }
      }

      // If mode is "limited" but selection includes any folder, switch to "public" because folders don't support limited.
      if (mode === "limited" && hasFolders) {
        mode = "public";
      }

      setAccessMode(mode);
      setPublicUntilValue(puVal);
      setMaxDownloadsValue(mdVal);
      setAccessDialogOpen(true);
    };

    const handleSetAccess = () => {
        if (!accessMode || !selectedItems) return;
        const items = Array.from(selectedItems);
        const ids = items.map(i => i._id);
        if (ids.length === 0) return;

        // For "limited" mode, backend doesn't support folders.
        // We'll send all IDs; backend will reject per-folder in partial-success response.
        util.postRequest("/api/content/setAccess", {
            ids,
            accessMode: accessMode,
            publicUntil: accessMode === "public_until" ? new Date(publicUntilValue).toISOString() : null,
            maxDownloads: accessMode === "limited" ? Number(maxDownloadsValue) || 10 : null,
        })
            .then((res) => {
                setAccessDialogOpen(false);

                if (res.failed && Object.keys(res.failed).length > 0) {
                    // Build a short summary for partial failures
                    const failed = res.failed;
                    const messageLines = Object.entries(failed)
                        .slice(0, 4)
                        .map(([id, reason]) => `${reason}`);
                    const more = Object.keys(failed).length > 4 ? ` (+${Object.keys(failed).length - 4} more)` : "";
                    snackCaller(`Partially applied; ${res.succeededCount || 0} succeeded. Issues:${more}\n${messageLines.join("\n")}`);
                } else {
                    snackCaller(res.message || "Access settings updated");
                }

                refreshFileReferences();
            })
            .catch(() => {
                setAccessDialogOpen(false);
            });
    };

    return (
        <Box
            style={{ marginTop: 20, margin: 0 }}
            onDragOver={handleDrag}
            onDragEnter={handleDrag}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
        >
            <Dialog
                open={fileModalVisible}
                transitionDuration={0}
                onClose={closeFileViewer}
                sx={{
                    backgroundColor: "#00000000"
                }}
                PaperProps={{
                    style: {
                        backgroundColor: "#00000000"
                    }
                }}
                maxWidth
                fullScreen
            >
                <FileViewer
                    setFileModalData={setFileModalData}
                    fileModalData={fileModalData}
                    fileDatas={fileDatas}
                    setFileModalVisible={setFileModalVisible}
                    onClose={closeFileViewer}
                />
            </Dialog>
            <Dialog
                open={historyDialog}
                onClose={() => {
                    setHistoryDialog(false)
                    setHistoryItem(null)
                    setHistoryVersions([])
                }}
            >
                <DialogTitle>Details & History</DialogTitle>
                <DialogContent sx={{ minWidth: 420 }}>
                    {historyItem && (
                        <Box sx={{ mb: 2 }}>
                            <DialogContentText>
                                {historyItem.filename?.split("$Ğ!Ğ$")[0]}
                            </DialogContentText>
                            <Typography variant="body2" color="text.secondary">
                                {`Version ${historyItem.version ?? 0} • ${historyItem.mimetype || "unknown"}${historyItem.size != null ? ` • ${formatBytes(historyItem.size)}` : ""}`}
                            </Typography>
                            <Typography variant="caption" color="text.secondary" sx={{ wordBreak: "break-all" }}>
                                {`ETag ${historyItem.etag || "—"}`}
                            </Typography>
                        </Box>
                    )}
                    {historyLoading ? (
                        <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
                            <CircularProgress size={28} />
                        </Box>
                    ) : historyVersions.length <= 1 ? (
                        <DialogContentText>No earlier versions yet.</DialogContentText>
                    ) : (
                        <List dense>
                            {historyVersions.map((v) => (
                                <ListItem
                                    key={v._id}
                                    secondaryAction={
                                        <Button size="small" onClick={() => viewHistoryVersion(v)}>
                                            Download
                                        </Button>
                                    }
                                >
                                    <ListItemText
                                        primary={`Version ${v.version}${v.current ? " (current)" : ""}`}
                                        secondary={`${formatBytes(v.size)} • ${new Date(v.created).toLocaleString()}`}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        setHistoryDialog(false)
                        setHistoryItem(null)
                        setHistoryVersions([])
                    }}>Close</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={renameDialog}
                onClose={() => {
                    setRenameDialog(false)
                    setRenameFilename("")
                }}
            >
                <DialogTitle>Rename {selectedItem()?.type === "folder" ? "Folder" : "File"}</DialogTitle>
                <DialogContent>
                    <DialogContentText>Renaming a file won't change its URL</DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        sx={{ marginTop: 2 }}
                        label="New Name"
                        type="text"
                        fullWidth
                        value={renameFilename}
                        onChange={(e) => setRenameFilename(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        setRenameDialog(false)
                        setRenameFilename("")
                    }}>Cancel</Button>
                    <Button onClick={() => {
                        const item = selectedItem();
                        // Renaming onto an existing file name is an in-place replace, so the
                        // sibling by that name is replaced (and versioned) instead of duplicated.
                        const collision = fileDatas.find(f =>
                            f.type === "file" &&
                            f._id !== item._id &&
                            renameFilename === f.filename?.split("$Ğ!Ğ$")[0]);
                        util.postRequest("/api/content/rename", { id: item._id, name: renameFilename }).then(() => {
                            if (collision) return util.postRequest("/api/content/delete", { id: [collision._id] }).catch(() => { });
                        }).then(() => {
                            refreshFileReferences(undefined, true);
                        })
                        setRenameDialog(false)
                        setRenameFilename("")
                    }}>Rename</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={accessDialogOpen}
                onClose={() => setAccessDialogOpen(false)}
            >
                <DialogTitle>Access / Sharing</DialogTitle>
                <DialogContent sx={{ minWidth: 360 }}>
                    {Array.isArray(selectedItems) && selectedItems.length > 1 ? (
                        <Typography gutterBottom>This will update the access settings for all selected items at once.</Typography>
                    ) : selectedItem() && selectedItem().accessMode !== "private" ? (
                      <Typography gutterBottom>{`This item is currently: ${selectedItem().accessMode}. Choose how others can access it:`}</Typography>
                    ) : (
                      <Typography gutterBottom>This item is private. Choose how others can access it:</Typography>
                    )}

                    {selectedItems?.some(i => i.type === "folder") && (
                      <Typography sx={{ mt: 1, mb: 1, fontSize: 13, color: "text.secondary" }}>
                        For folders: public means anyone with the link can browse its contents; upload remains restricted to you. Limited downloads only apply to files.
                      </Typography>
                    )}

                    <RadioGroup
                        value={accessMode}
                        onChange={(e) => setAccessMode(e.target.value)}
                        sx={{ mt: 1, mb: 2 }}
                    >
                        <FormControlLabel
                            value="private"
                            control={<Radio />}
                            label="Private – only you can access."
                        />
                        <FormControlLabel
                            value="public"
                            control={<Radio />}
                            label={selectedItems?.some(i => i.type === "folder")
                                ? "Public – anyone with the link can view/download (files) or browse contents (folders)."
                                : "Public – anyone with the link can view/download."}
                        />

                        <FormControlLabel
                            value="public_until"
                            control={<Radio />}
                            label={selectedItems?.some(i => i.type === "folder")
                                ? "Public until (becomes private after expiration)"
                                : "Public until (file becomes private after expiration)"}
                        />

                        {accessMode === "public_until" && (
                            <TextField
                                fullWidth
                                type="datetime-local"
                                label="Expires at"
                                value={publicUntilValue}
                                onChange={(e) => setPublicUntilValue(e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                sx={{ mt: 1, mb: 2 }}
                            />
                        )}

                        {!selectedItems?.some(i => i.type === "folder") && (
                          <>
                            <FormControlLabel
                                value="limited"
                                control={<Radio />}
                                label="Limited downloads (file becomes private after limit is reached)"
                            />

                            {accessMode === "limited" && (
                                <TextField
                                    fullWidth
                                    type="number"
                                    label="Max number of downloads (global across all users)"
                                    inputProps={{ min: 1 }}
                                    value={maxDownloadsValue}
                                    onChange={(e) => setMaxDownloadsValue(e.target.value)}
                                    sx={{ mt: 1, mb: 2 }}
                                />
                            )}
                          </>
                        )}
                    </RadioGroup>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setAccessDialogOpen(false)}>Cancel</Button>
                    <Button
                        variant="contained"
                        disabled={
                            !accessMode ||
                            (accessMode === "public_until" && (!publicUntilValue || new Date(publicUntilValue) < new Date())) ||
                            (accessMode === "limited" && (!maxDownloadsValue || Number(maxDownloadsValue) <= 0))
                        }
                        onClick={() => handleSetAccess()}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>

            <Box
                sx={{
                    width: "100%",
                    height: "100%",
                    display: dragging ? "flex" : "none",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "fixed",
                    top: 0,
                    left: 0,
                    backgroundColor: dragging ? "rgba(0, 0, 0, 0.5)" : "transparent",
                    zIndex: dragging ? 100 : -1
                }}
            >
                <Typography
                    sx={{
                        color: "#fff",
                        fontSize: 40,
                        fontFamily: "Russo One",
                        fontWeight: 100,
                    }}
                >
                    Drop Files Here
                </Typography>
            </Box>

            <Dialog
                open={newFolderDialog}
                onClose={() => setNewFolderDialog(false)}
            >
                <DialogTitle>Create New Folder</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label="Folder Name"
                        type="text"
                        fullWidth
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setNewFolderDialog(false)}>Cancel</Button>
                    <Button onClick={() => {
                        let parent = currentDir === "/" ? null : currentDir.split("/").filter(p => p !== "").pop();
                        parent = fileDatas.find(f => f.filename === parent && f.type === "folder")?._id || null;

                        util.postRequest("/api/content/createFolder", { filename: document.getElementById("name").value, parent: currentParent }).then((res) => {
                            refreshFileReferences(undefined, true);
                        })
                        setNewFolderDialog(false)
                    }}>Create</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={deleteItemDialog}
                onClose={onDeleteDialogClose}
            >
                <DialogTitle>Move to Recycle Bin?</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {Array.isArray(selectedItem()) && selectedItem()?.length > 1
                            ? `${selectedItem().length} selected items will be moved to the recycle bin.`
                            : `${selectedItem()?.type === "folder" ? "This folder" : "This file"} will be moved to the recycle bin.`}
                        {" "}You can restore it for 30 days.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onDeleteDialogClose}>Cancel</Button>
                    <Button onClick={() => {
                        util.postRequest("/api/content/delete", { id: Array.isArray(selectedItem()) ? selectedItem().map(i => i._id) : [selectedItem()._id] }).then((res) => {
                            refreshFileReferences(undefined, true);
                        })
                        onDeleteDialogClose()
                    }}>Move to bin</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={trashOpen}
                onClose={() => setTrashOpen(false)}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Recycle bin{trashTotal > 0 ? ` (${trashTotal})` : ""}</DialogTitle>
                <DialogContent dividers>
                    {trashLoading ? (
                        <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
                            <CircularProgress size={22} />
                        </Box>
                    ) : trashItems.length === 0 ? (
                        <DialogContentText>Nothing here. Deleted items are kept for 30 days.</DialogContentText>
                    ) : (
                        <List dense disablePadding>
                            {trashItems.map((item) => (
                                <ListItem
                                    key={item._id}
                                    secondaryAction={
                                        <>
                                            <Tooltip title="Restore">
                                                <span>
                                                    <IconButton size="small" disabled={trashBusy} onClick={() => restoreTrashItem(item._id)}>
                                                        <RestoreFromTrash fontSize="small" />
                                                    </IconButton>
                                                </span>
                                            </Tooltip>
                                            <Tooltip title="Delete forever">
                                                <span>
                                                    <IconButton size="small" disabled={trashBusy} onClick={() => { setPurgeTarget(item._id); setPurgePassword(""); }}>
                                                        <DeleteForeverOutlined fontSize="small" />
                                                    </IconButton>
                                                </span>
                                            </Tooltip>
                                        </>
                                    }
                                >
                                    <Box sx={{ display: "flex", alignItems: "center", mr: 1 }}>
                                        {item.type === "folder" ? <FolderOutlined fontSize="small" /> : <InsertDriveFileOutlined fontSize="small" />}
                                    </Box>
                                    <ListItemText
                                        primary={item.filename}
                                        secondary={`${item.type === "folder" ? "Folder" : formatBytes(item.size)} \u00b7 ${item.daysLeft} day${item.daysLeft === 1 ? "" : "s"} left`}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button
                        color="error"
                        disabled={trashBusy || trashItems.length === 0}
                        onClick={() => { setPurgeTarget("ALL"); setPurgePassword(""); }}
                    >
                        Empty bin
                    </Button>
                    <Button onClick={() => setTrashOpen(false)}>Close</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={purgeTarget !== null}
                onClose={() => { if (!trashBusy) { setPurgeTarget(null); setPurgePassword(""); } }}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle>{purgeTarget === "ALL" ? "Empty the recycle bin?" : "Delete forever?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ mb: 2 }}>
                        This permanently deletes the content and cannot be undone. Enter your account password to confirm.
                    </DialogContentText>
                    <TextField
                        autoFocus
                        fullWidth
                        label="Password"
                        type="password"
                        value={purgePassword}
                        onChange={(e) => setPurgePassword(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" && purgePassword && !trashBusy) confirmPurge();
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setPurgeTarget(null); setPurgePassword(""); }} disabled={trashBusy}>Cancel</Button>
                    <Button color="error" onClick={confirmPurge} disabled={trashBusy || !purgePassword}>Delete forever</Button>
                </DialogActions>
            </Dialog>

            <Menu
                open={contextMenu !== null}
                onClose={() => onContextMenuClose(true)}
                anchorReference="anchorPosition"
                anchorPosition={
                    contextMenu !== null
                        ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                        : undefined
                }
            >
                {selectedItem()?.type === "file" && <MenuItem onClick={() => {
                    const target = selectedItem();
                    const anchor = document.createElement("a");
                    anchor.href = target.url;
                    anchor.download = target.filename?.split("$Ğ!Ğ$")[0] || "download";
                    anchor.target = "_blank";
                    anchor.rel = "noreferrer";
                    document.body.appendChild(anchor);
                    anchor.click();
                    document.body.removeChild(anchor);
                    onContextMenuClose();
                }}>Download</MenuItem>}
                {!Array.isArray(selectedItem()) && (selectedItem()?.type === "file" || selectedItem()?.type === "folder") && <MenuItem onClick={() => {
                    const item = selectedItem();
                    let link;

                    if (item.type === "folder") {
                        // Use contentManager with ?folder=ID so shared folder can be opened directly.
                        link = `${window.location.origin}${window.location.pathname}#/contentManager?folder=${encodeURIComponent(item._id)}`;
                    } else {
                        // For files, use file URL directly (already built with token if needed)
                        link = item.url;
                    }

                    navigator.clipboard.writeText(link)
                        .then(() => snackCaller("Copied to Clipboard"))
                        .catch(() => snackCaller("Failed to copy link"));
                    onContextMenuClose();
                }}>Copy Link</MenuItem>}
                {(selectedItems?.length || selectedItem()) && <MenuItem onClick={() => {
                    openAccessDialog();
                    onContextMenuClose(false);
                }}>Access / Sharing{Array.isArray(selectedItems) && selectedItems.length > 1 ? ` (${selectedItems.length})` : ""}</MenuItem>}
                {!Array.isArray(selectedItem()) && <MenuItem onClick={() => {
                    setRenameDialog(true);
                    setRenameFilename(selectedItem().filename.split("$Ğ!Ğ$")[0])
                    onContextMenuClose();
                }}>Rename</MenuItem>}
                {selectedItem()?.type === "file" && <MenuItem onClick={() => {
                    openHistoryDialog(selectedItem());
                    onContextMenuClose();
                }}>Details & History</MenuItem>}
                {
                    selectedItem()?.parent !== null && currentParent !== null &&
                    <MenuItem onClick={() => {
                        util.postRequest("/api/content/move", { id: selectedItem()._id, parent: "/" }).then((res) => {
                            refreshFileReferences(undefined, true);
                        })
                        onContextMenuClose();
                    }}>Move Up</MenuItem>}
                <MenuItem onClick={() => {
                    setDeleteItemDialog(true);
                    onContextMenuClose();
                }}>Delete</MenuItem>
            </Menu>
            <Box
                sx={{
                    height: "calc(100vh - 70px)",
                    backgroundColor: "#151515",
                }}
            >
                <Box
                    sx={{
                        width: "100%",
                        height: 40,
                        backgroundColor: "#202020",
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <IconButton
                        onClick={goBackOne}
                        disabled={currentDir === "/"}
                    >
                        <ArrowBack />
                    </IconButton>

                    {
                        currentParent !== null && <IconButton
                            onClick={goHome}
                        >
                            <Home />
                        </IconButton>
                    }

                    <Typography
                        sx={{
                            color: "#fff",
                            margin: "auto",
                            marginTop: isDragging && currentDir !== "/" ? 0.3 : 1.7,
                            fontSize: isDragging && currentDir !== "/" ? 26 : 16,
                            lineHeight: isDragging && currentDir !== "/" ? "40px" : "16px",
                            transition: "200ms",
                            fontFamily: "Russo One",
                        }}
                        onDragOver={(event) => {
                            event.preventDefault()
                        }}
                        onDrop={(event) => {
                            if (currentDir === "/") return;
                            event.preventDefault();
                            const destinationParent = pathStack.length > 1
                                ? pathStack[pathStack.length - 2]._id
                                : null;
                            goBackOne();

                            util.postRequest("/api/content/move", { id: event.dataTransfer.getData("text/plain"), parent: destinationParent }).then((res) => {
                                refreshFileReferences(undefined, true);
                            })
                        }}
                    >
                        {!isDragging || currentDir === "/" ? `/${user.username ?? "Anonymous"}${currentDir.replace(/\$Ğ!Ğ\$.{6}/g, '')}` : "DRAG HERE TO MOVE UP"}
                    </Typography>

                    {user.username != null && <Box
                        sx={{

                        }}
                    >
                        <FormControl size="small" sx={{ minWidth: 160 }}>
                            <InputLabel id="sort-by-label">Sort By</InputLabel>
                            <Select
                                labelId="sort-by-label"
                                value={sortBy}
                                label="Sort By"
                                onChange={(e) => {
                                    const next = Number(e.target.value);
                                    setSortBy(next);
                                    localStorage.setItem("cdnSortBy", String(next));
                                }}
                            >
                                <MenuItem value={0}>Updated</MenuItem>
                                <MenuItem value={1}>Name</MenuItem>
                                <MenuItem value={2}>Size</MenuItem>
                                <MenuItem value={3}>Type</MenuItem>
                            </Select>
                        </FormControl>

                        <FormControl size="small" sx={{ minWidth: 140 }}>
                            <InputLabel id="sort-order-label">Order</InputLabel>
                            <Select
                                labelId="sort-order-label"
                                value={sortOrder}
                                label="Order"
                                onChange={(e) => {
                                    const next = Number(e.target.value);
                                    setSortOrder(next);
                                    localStorage.setItem("cdnSortOrder", String(next));
                                }}
                            >
                                <MenuItem value={-1}>Descending</MenuItem>
                                <MenuItem value={1}>Ascending</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>}

                    {user.username != null && <IconButton
                        onClick={() => navigate("/contentManager/gallery")}
                    >
                        <PhotoLibrary />
                    </IconButton>}

                    {user.username != null && <IconButton
                        onClick={openTrash}
                        title="Recycle bin"
                    >
                        <DeleteSweep />
                    </IconButton>}

                    {user.username != null && <IconButton
                        onClick={() => setNewFolderDialog(true)}
                    >
                        <CreateNewFolderOutlined />
                    </IconButton>}

                    {user.username != null && <IconButton
                        onClick={(event) => {
                            // Create a click event
                            var clickEvent = new MouseEvent("click", {
                                "view": window,
                                "bubbles": true,
                                "cancelable": false
                            });

                            // Create an input element and set its attributes
                            var fileInput = document.createElement("INPUT");
                            fileInput.setAttribute("type", "file");
                            // allow multiple files
                            fileInput.setAttribute("multiple", "multiple");
                            fileInput.style.display = "none"; // Hide the input element

                            // Add an event listener to handle the selected files
                            fileInput.addEventListener("change", (event) => {
                                handleDrop(event.target.files); // Call handleDrop with the selected files
                            });

                            // Append the input element to the body
                            document.body.appendChild(fileInput);

                            // Dispatch the click event on the input element
                            fileInput.dispatchEvent(clickEvent);


                        }}
                    >
                        <UploadFileOutlined />
                    </IconButton>}

                    {user.username != null && <Dialog
                        open={concurrenceDialog}
                        onClose={() => setConcurrenceDialog(false)}
                    >
                        <DialogTitle>Settings</DialogTitle>
                        <DialogContent sx={{ display: "flex", flexDirection: "column" }}>
                            <Typography gutterBottom>Concurrence allows you to set how many files can be uploaded at once</Typography>
                            <TextField
                                autoFocus
                                margin="dense"
                                id="name"
                                label="Concurrence"
                                type="number"
                                inputProps={{
                                    min: 1
                                }}
                                fullWidth
                                value={concurrenceInput}
                                onChange={(e) => setConcurrenceInput(e.target.value)}
                            />

                            <Typography gutterBottom>Upload Chunk Concurrence allows you to set how many chunks are uploaded at once per file</Typography>
                            <TextField
                                margin="dense"
                                id="uploadChunkConcurrence"
                                label="Upload Chunk Concurrence"
                                type="number"
                                inputProps={{
                                    min: 1,
                                    max: 16
                                }}
                                fullWidth
                                value={uploadChunkConcurrenceInput}
                                onChange={(e) => setUploadChunkConcurrenceInput(e.target.value)}
                            />

                            <Typography gutterBottom>Thumbnails {thumbnailVisible ? "Visible" : "Disabled"}</Typography>
                            <Switch
                                checked={thumbnailVisible}
                                onChange={(e) => {
                                    setThumbnailVisible(e.target.checked)
                                    util.postRequest("/api/auth/setThumbnail", { thumbnail: e.target.checked }).then((res) => {
                                        snackCaller("Thumbnail Visibility Updated")
                                    }).catch((err) => {
                                        snackCaller(err.message)
                                    })
                                }}
                            />

                            <Typography gutterBottom>Always Fully Load Folders</Typography>
                            <Switch
                                sx={{ mt: 1 }}
                                checked={alwaysFullLoad}
                                onChange={(e) => {
                                    console.log("Setting Always Full Load to ", e.target.checked)
                                    const enabled = e.target.checked;
                                    setAlwaysFullLoad(enabled);
                                    localStorage.setItem("cdnAlwaysFullLoad", String(enabled));
                                }}
                                label="Always load full page"
                            />

                            <Typography gutterBottom>Disk Cache {disableDiskCache ? "Disabled" : "Enabled"}</Typography>
                            <Switch
                                sx={{ mt: 1 }}
                                checked={disableDiskCache}
                                onChange={async (e) => {
                                    const enabled = e.target.checked;
                                    setDisableDiskCache(enabled);
                                    localStorage.setItem("ifmwDisableDiskCache", String(enabled));
                                    window.disableDiskCache = enabled;

                                    if (enabled && window.clearLocalMediaCache) {
                                        await window.clearLocalMediaCache();
                                        snackCaller("Disk cache disabled and local cache cleared");
                                    }
                                }}
                            />

                            <Button
                                sx={{ mt: 1, alignSelf: "flex-start" }}
                                variant="outlined"
                                onClick={async () => {
                                    if (window.clearLocalMediaCache) {
                                        await window.clearLocalMediaCache();
                                        snackCaller("Local cache cleared");
                                    } else {
                                        snackCaller("Local cache clear unavailable");
                                    }
                                }}
                            >
                                Clear Local Cache
                            </Button>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setConcurrenceDialog(false)}>Cancel</Button>
                            <Button onClick={async () => {
                                setConcurrenceDialog(false)
                                try {
                                    await util.postRequest("/api/auth/setConcurrence", {
                                        concurrence: concurrenceInput
                                    });
                                    await util.postRequest("/api/auth/setUploadChunkConcurrence", {
                                        uploadChunkConcurrence: uploadChunkConcurrenceInput
                                    });
                                    const updatedUser = JSON.parse(localStorage.getItem("user") || "{}");
                                    updatedUser.concurrence = parseInt(concurrenceInput, 10) || 1;
                                    updatedUser.uploadChunkConcurrence = parseInt(uploadChunkConcurrenceInput, 10) || 1;
                                    localStorage.setItem("user", JSON.stringify(updatedUser));
                                    setUser(updatedUser);
                                } catch (err) {
                                    snackCaller(err.message)
                                }
                            }}>Save</Button>
                        </DialogActions>
                    </Dialog>}

                    {user.username != null && <IconButton
                        onClick={() => refreshFileReferences(undefined, true)}
                    >
                        <Refresh />
                    </IconButton>}

                    {user.username != null && <IconButton
                        onClick={() => setConcurrenceDialog(true)}
                    >
                        <Settings />
                    </IconButton>}

                    {user.username != null && <IconButton
                        onClick={() => navigate("/contentManager/search")}
                    >
                        <Search />
                    </IconButton>}
                </Box>

                <Box
                    sx={{
                        height: "calc(100vh - 150px)",
                        padding: "18px",
                        paddingTop: 0,
                        overflow: 'hidden',
                    }}
                    ref={gridParentRef}
                >
                    {
                        error ?
                            <Box
                                sx={{
                                    marginTop: "30vh"
                                }}
                            >
                                <Warning
                                    htmlColor={"#cc0000"}
                                    sx={{
                                        fontSize: 50
                                    }}
                                />

                                <Typography
                                    sx={{
                                        color: "#fff",
                                        textAlign: "center"
                                    }}
                                >
                                    Failed to load folder listing.
                                </Typography>
                            </Box>
                            :
                            loading ?
                                <Box
                                    sx={{
                                        marginTop: "30vh"
                                    }}
                                >
                                    <CircularProgress
                                        color="primary"
                                        size={50}
                                    />
                                </Box>
                                :
                                <GridView
                                    columnCount={columnCount}
                                    itemWidth={itemWidth}
                                    gridWidth={gridWidth}
                                    gridHeight={gridHeight}
                                    gridRef={gridRef}
                                    refreshFileReferences={refreshFileReferences}
                                    dragStart={dragStart}
                                    handleItemClick={handleItemClick}
                                    selectedItems={selectedItems}
                                    setContextMenu={setContextMenu}
                                    setSelectedItem={setSelectedItem}
                                    fileData={fileData}
                                    hasMore={hasMore}
                                    alwaysFullLoad={alwaysFullLoad}
                                    disableDiskCache={disableDiskCache}
                                />
                    }
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        width: "100%",
                        overflowY: "auto",
                        height: 40,
                        backgroundColor: "#202020",
                        alignItems: "center",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            paddingLeft: 2,
                            paddingRight: 2,
                            height: 40,
                            backgroundColor: "#303030",
                            position: "relative",
                        }}
                    >
                        <div
                            style={{
                                height: 40,
                                width: `${(usage / allowance) * 100}%`,
                                display: "flex",
                                position: "absolute",
                                backgroundColor: "#454545",
                                left: 0,
                            }}
                        />

                        <Typography
                            sx={{
                                color: "#fff",
                                margin: "auto",
                                zIndex: 1,
                            }}
                        >
                            {usage?.toFixed(2)}/{allowance}MB
                        </Typography>
                    </Box>

                    <Typography
                        sx={{
                            color: "#fff",
                            marginLeft: 2
                        }}
                    >
                        {fileData().filter(f => f.type === "file").length} Files, {fileData().filter(f => f.type === "folder").length} Folders
                    </Typography>

                    {(selectedItems?.length || 0 > 0) && <Typography
                        sx={{
                            color: "#fff",
                            marginLeft: 4
                        }}
                    >
                        {selectedItems?.length || 0} Selected Item{selectedItems?.length > 1 ? "s" : ""}
                    </Typography>}

                    {(selectedItems?.length || 0 > 0) && <Typography
                        sx={{
                            color: "#fff",
                            marginLeft: 4
                        }}
                    >
                        {getSize()}
                    </Typography>}
                </Box>
            </Box>
        </Box >
    );
};

export default CDNRoot;